import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { DataService } from "src/app/data.service";
import { FormBuilder } from "@angular/forms";

export interface PeriodicElement {
  label: string;
  name: string;
}

@Component({
  selector: "app-searchlayout",
  templateUrl: "./searchlayout.component.html",
  styleUrls: ["./searchlayout.component.scss"],
})
export class SearchlayoutComponent implements OnInit {
  detailForm = this.fb.group({
    metaobjectid: "",
    metaobjectname: "",
    id: "",
    targetobject: "",
    targetobjectid: "",
    objectid: "",
    labelname: "",
    name: "",
    buttontype: "",
    actiontype: "",
    content: "",
    parentobjectid: "",
    parentobjectname: "",
    description: "",
    metalayoutid: "",
  });
  matSort: any;
  paginator: any;
  guid: any;
  searchlayout:any;
  profileId: any;
  // actionForm:FormGroup
  isLoading = false;
  isError = false;
  errorMessage = "";

  metaobjectList = [];
  // dataSource = new MatTableDataSource();
  name: any;
  metaobjectId = "";
  metaobjectName = "";
  parentObjects: any[];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private dataService: DataService,
    private _router: Router
  ) {}
  // constructor(){

  // }

  ngOnInit() {
    this.getActiveObjectsByType().then((res) => {
      console.log("response11111", res);
      console.log("parentobjects", this.parentObjects);
    });
  }
  displayedColumns: string[] = ["label", "name"];
  dataSource: any;

  getActiveObjectsByType() {
    return new Promise((resolve, reject) => {
      console.log("getActiveObjectsByType");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          metaobject: {
            objecttype: "Domain",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveObjectsByType(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            var activeObjects = res.data.metaobjects;
            var objArr = [];
            //just add an empty entry sice this field is optional
            for (let i = 0; i < activeObjects.length; i++) {
              objArr.push({
                objectid: activeObjects[i].id,
                objectname: activeObjects[i].name,
              });
            }
            this.parentObjects = objArr;

            if (this.parentObjects != null) {
              this.dataSource = this.parentObjects.map((item) => ({
                label: item.objectname,
                objectid: item.objectid,
              }));
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }
}
